<template>
  <div>
    <el-dialog :title="computingPowerType === 2 ? '常规算力充值' : 'AI算力充值'" :visible.sync="payShow" width="40%" center :append-to-body="true">
      <el-form label-width="100px" :model="payFrom" class="opts_line">
        <el-form-item label="充值数量：" required>
          <div class="paySelect">
            <div class="norBox" :class="payType==1&&thisNum==item?'hovBox':''" @click="onGoodsPay(1,item)" v-for="(item,index) in option_list" :key="index">
              {{ item }}{{ unit }}</div>
            <div class="norBox" :class="payType==2?'hovBox':''" @click="onGoodsPay(2)">其他
              <el-input placeholder="请输入数量" :min="min_num || 1" v-model="otherNum" :step="1" type="Number" style="width: 110px"
                        size="mini" ></el-input>
              {{ unit }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="价格：" required>
          <div style="color: red;font-weight: bold;font-size: 20px">￥{{ payPrice }}  </div>
        </el-form-item>
        <recharge-campaign-tip :visible="payShow" :computing-power-type="computingPowerType" :quantity="payType==1 ? thisNum : otherNum" />
        <el-form-item label="充值方式：" required>
          <!--          <div class="norBox hovBox" style="background-color: rgb(2,167,240);color:#ffffff">支付宝</div>-->
          <div class="norBox hovBox" style="background-color: rgb(2,167,240);color:#ffffff">余额<span style="font-size: 12px">（可用余额：{{ userInfo.money }}）</span></div>
        </el-form-item>
        <el-form-item label=""  required>
          <el-button type="primary" @click="onSubmit" :loading="loading">立即充值</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapState, mapMutations} from "vuex";
import RechargeCampaignTip from '@/components/recharge/RechargeCampaignTip.vue';

export default {
  components: { RechargeCampaignTip },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: function (){
        return {}
      }
    },
    computingPowerType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      loading: false,
      payShow: false,
      payFrom: {},
      payType: 1,
      thisNum:'',
      otherNum: '',
      info:{},
      option_list:[1000, 2000, 3000, 5000, 10000, 20000, 50000] ,
      unit_price:0.01,
      min_num:0,
      price:'',
      unit:'',
    };
  },

  created() {
  },
  mounted() {
  },
  computed:{
    payPrice(){
      if(this.payType==1){
        return Number(this.unit_price*this.thisNum).toFixed(2)
      }else{
        return Number(this.unit_price*this.otherNum).toFixed(2)
      }
    }
  },
  methods: {
    ...mapActions({
      opPowerRecharge: "ucenter/opPowerRecharge",
    }),
    show(row) {
      this.info = row
      this.payType = 1
      this.otherNum = ''
      this.price = ''
      this.payShow = true
    },
    onGoodsPay(type,item) {
      this.payType = type
      if(type==1){
        this.thisNum = item
      }
      // this.getPrice()
    },

    onSubmit() {
      if (this.loading) {
        return
      }
      let num = this.thisNum
      if(this.payType==2){
        num = this.otherNum
      }
      if (!/^[1-9]\d{0,13}$/.test(String(num)) || Number(num) < this.min_num) {
        this.$message.warning('请输入正整数充值数量');
        return
      }
      this.loading = true
      let param = {num:num, computing_power_type: this.computingPowerType}
      this.opPowerRecharge({
        data: param, success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.$message.success('充值成功')
            this.payShow = false
            this.$emit('refresh')
          } else {
            this.$message({message: res.message, type: 'error'})
          }
        }
      })
    },


    getPrice(){
      if(this.payType==1){
        this.price = Number(this.unit_price*this.thisNum).toFixed(2)
      }else{
        this.price = Number(this.unit_price*this.otherNum).toFixed(2)
        /* if(this.otherNum >= this.min_num){
         }else{
           this.price = 0
         }*/
      }
    },
    formatTime(time){
      if(!time) return ''
      const date = new Date(time * 1000)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${year}-${month}-${day}`
    },
  },

}
</script>

<style scoped>

.paySelect {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.norBox {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 2px 12px;
  margin-right: 10px;
  cursor: pointer;
  width: fit-content;
  margin-bottom: 10px;
}

.hovBox {
  background: rgb(196, 237, 255);
  border: 1px solid rgb(196, 237, 255);
}
</style>
